'use client';

import { Icons } from '@/components/icons';

interface FileDropZoneProps {
  readonly label: string;
  readonly description?: string;
  readonly accept?: string;
  readonly onFiles: (files: FileList) => void;
}

export function FileDropZone({
  label,
  description,
  accept,
  onFiles,
}: FileDropZoneProps) {
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files) {
      onFiles(e.target.files);
      e.target.value = '';
    }
  }

  function handleDrop(e: React.DragEvent<HTMLLabelElement>) {
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
      onFiles(e.dataTransfer.files);
    }
  }

  return (
    <label
      className='flex cursor-pointer flex-col items-center gap-3 rounded-lg border-2 border-dashed border-black/30 bg-black/5 px-6 py-8 text-center transition-colors hover:border-black/50 hover:bg-black/10 print:hidden'
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
    >
      <Icons.cloudUpload className='size-8 text-black/60' />
      <div>
        <span className='text-sm font-medium text-foreground'>{label}</span>
        {description && (
          <p className='mt-1 text-xs text-muted-foreground'>{description}</p>
        )}
      </div>
      <input
        type='file'
        multiple
        accept={accept}
        className='sr-only'
        onChange={handleChange}
      />
    </label>
  );
}
